// TODO: (@josh): This file should be deprecated and removed in favor of WorkspaceComments.actions

import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EventTypes } from 'redux-segment';
import { v4 as uuidv4 } from 'uuid';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { segmentMetaWithPayload } from 'Shared/helpers';
import { handleRequestError } from 'Shared/utils/handle-request-error';
import { getSourcePage } from 'Shared/utils/getSourcePage';

import { updateComment, createComment, destroyComment, destroyCommentAttachments } from '../api/comments';
import { createCommentData, createWorkspaceCommentData } from './utils';
import { getCurrentWorkspaceType } from 'Shared/selectors/common';

export function useUpdateWorkspaceComment({ meetingItem }) {
  const dispatch = useDispatch();

  const request = useCallback(
    async ({ uuid, body, video }) => {
      await handleRequestError(updateComment({ uuid, data: { body, video } }))
        .then(response => {
          return dispatch({
            type: 'UPDATE_COMMENT_ITEM_RESPONSE',
            meetingItemType: meetingItem.itemType,
            payload: { meetingItem, workspaceComment: response.data },
          });
        })
        .catch(e => {
          WpToastManager.danger(e.message);
          return e;
        });
    },
    [dispatch, meetingItem]
  );

  return [request];
}

export function useCreateWorkspaceComment({ meetingItem }) {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const appId = useSelector(state => state.app.id);
  const clientSyncToken = useSelector(state => state.app.clientSyncToken);
  const workspaceType = useSelector(getCurrentWorkspaceType());
  const request = useCallback(
    ({ body, video, meetingModeSessionId }) => {
      const uuid = uuidv4();
      const workspaceComment = createWorkspaceCommentData({
        uuid,
        body,
        meetingItem,
        user,
        video,
        meetingModeSessionId,
      });
      dispatch({
        type: 'CREATE_WORKSPACE_COMMENT_REQUEST',
        meetingItemType: meetingItem.itemType,
        payload: { meetingItem, workspaceComment },
        meta: segmentMetaWithPayload({
          event: 'Added Comment',
          properties: { app_id: appId, sourcePage: getSourcePage(), itemType: meetingItem.itemType, workspaceType },
        }),
      });
      return handleRequestError(
        createComment(
          createCommentData({ uuid, body, video, meetingItemId: meetingItem.id, meetingModeSessionId, clientSyncToken })
        )
      )
        .then(response => {
          return dispatch({
            type: 'CREATE_WORKSPACE_COMMENT_RESPONSE',
            meetingItemType: meetingItem.itemType,
            payload: { meetingItem, workspaceComment: response.data },
          });
        })
        .catch(e => {
          WpToastManager.danger(e.message);
          dispatch({
            type: 'CREATE_WORKSPACE_COMMENT_ERROR',
            meetingItemType: meetingItem.itemType,
            payload: { meetingItem, workspaceComment },
          });
          return e;
        });
    },
    [appId, dispatch, meetingItem, user]
  );

  return [request];
}

export function useDestroyCommentAttachment({ meetingItem }) {
  const dispatch = useDispatch();

  const request = useCallback(
    ({ uuid, attachmentId }) =>
      handleRequestError(destroyCommentAttachments(attachmentId))
        .then(() => {
          return dispatch({
            type: 'REMOVE_COMMENT_ATTACHMENT_RESPONSE',
            meetingItemType: meetingItem.itemType,
            payload: { meetingItem, commentUuid: uuid, attachmentId },
          });
        })
        .catch(e => {
          WpToastManager.danger(e.message);
          return e;
        }),
    [dispatch, meetingItem]
  );

  return [request];
}

export const destroyWorkspaceComment = ({ meetingItem, workspaceComment }) => (dispatch, getState) => {
  dispatch({
    type: 'DESTROY_WORKSPACE_COMMENT_REQUEST',
    meetingItemType: meetingItem.itemType,
    payload: { meetingItem, workspaceComment },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Removed Comment',
          properties: { app_id: getState().app.id, sourcePage: getSourcePage(), itemType: meetingItem.itemType },
        },
      },
    },
  });

  return handleRequestError(
    destroyComment({ uuid: workspaceComment.uuid, data: { clientSyncToken: getState().app.clientSyncToken } })
  )
    .then(response => {
      return dispatch({
        type: 'DESTROY_WORKSPACE_COMMENT_RESPONSE',
        meetingItemType: meetingItem.itemType,
        payload: { meetingItem, workspaceComment: response.data },
      });
    })
    .catch(e => {
      dispatch({
        type: 'DESTROY_WORKSPACE_COMMENT_ERROR',
        meetingItemType: meetingItem.itemType,
        payload: { meetingItem, workspaceComment },
      });
      WpToastManager.danger(e.message);
      return e;
    });
};
